import { render, staticRenderFns } from "./MyShops.vue?vue&type=template&id=522c351b&scoped=true&"
import script from "./MyShops.vue?vue&type=script&lang=js&"
export * from "./MyShops.vue?vue&type=script&lang=js&"
import style0 from "./MyShops.vue?vue&type=style&index=0&id=522c351b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522c351b",
  null
  
)

export default component.exports